import { IRouteModule } from "./types";
import { publicModule } from "./modules/public";
import { dashboardModule } from "./modules/dashboard";
import { alertsModule } from "./modules/alerts";
import { agenciesModule } from "./modules/agencies";
import { helpModule } from "./modules/help";
import { geosearchModule } from "./modules/geosearch";
import { newsModule } from "./modules/news";
import { settingsModule } from "./modules/settings";
import { adminModule } from "./modules/admin";
import { commonModule } from "./modules/common";
import { searchModule } from "./modules/search";
import { UserTypes } from "../Auth/store/types";
import { casesModule } from "src/modules/Routing/modules/cases";

export const modules = (userType: UserTypes): IRouteModule[] => [
  dashboardModule(userType),
  casesModule(),
  publicModule(),
  alertsModule(),
  agenciesModule(),
  searchModule(),
  geosearchModule(userType),
  newsModule(),
  helpModule(),
  adminModule(),
  settingsModule(),
  commonModule()
]


// WEBPACK FOOTER //
// ./src/modules/Routing/routesModule.ts